<div class="container-fluid">
  <h3>
    {{ 'events.settings.items.title' | translate | titlecase }}
    <span>
      <a href="https://support.weblinkinternational.com/hc/en-us/articles/235709787-Event-Settings-Event-Items" target="_blank">
        <img src="/assets/img/help.png" title="{{ 'events.settings.items.items-title-help' | translate }}" class="wc-help-icon" />
      </a>
    </span>
  </h3>

  <p>
    <button app-add-button
      dataCy="btnEventSettingsNewEventItem"
      [disabled]="userAccessLevel < 2"
      [label]="'events.settings.items.add-event-item-label' | translate | titlecase"
      (onClick)="newEventItem()"
    >
    </button>
  </p>

  <p>
    {{ 'events.settings.items.drag-drop-instructions' | translate }}
  </p>

  <p [hidden]="!loadingList.busy"><wl-busy [show]="loadingList.busy"></wl-busy> {{ 'common.loading' | translate | titlecase }}...</p>

  <div class="alert alert-danger" [hidden]="loadingList.busy || loadingList.success || !loadingList.message">
    {{ loadingList.message }}
  </div>

  <div cdkDropList (cdkDropListDropped)="handleEventItemDrop($event)" class="list-group" [hidden]="!eventItems?.length">
    <div cdkDrag class="list-group-item clear-fix" *ngFor="let eventItem of eventItems; let eventItemNdx = index">
      <span class="pull-right">
        <button
          pButton
          type="button"
          class="btn btn-default"
          (click)="editEventItem(eventItem.EventItemId)"
          [disabled]="loadingList.busy || userAccessLevel < 2"
          icon="pi pi-pencil"
        >
          {{ 'common.edit' | translate | titlecase }}
        </button>
        <button
          pButton
          class="btn btn-default"
          type="button"
          (click)="copyEventItem(eventItem)"
          [title]="'events.settings.items.copy-item' | translate | titlecase"
          icon="pi pi-copy"
        >
          <span class="sr-only">{{ 'events.settings.items.copy-item' | translate | titlecase }}</span>
        </button>
        <button
          pButton
          type="button"
          class="btn btn-danger"
          (click)="confirmDeleteEventItem(eventItem)"
          [title]="'common.delete' | translate | titlecase"
          [disabled]="loadingList.busy || userAccessLevel < 2"
          icon="pi pi-trash"
        >
          <span class="sr-only">{{ 'common.delete' | translate | titlecase }}</span>
        </button>
      </span>
      {{ eventItem.Descr }}
      <img
        class="wc-inline-icon"
        src="/assets/img/public-registration.png"
        [title]="'events.settings.items.public-registration-available' | translate"
        [alt]="'events.settings.items.public-registration-available' | translate"
        [hidden]="!eventItem.IsPublic"
      />
      <span
        *ngIf="!eventItem.HasMemberPricing"
        [title]="
          (eventItem.MembersOnly ? 'events.settings.items.member-price-column-header' : 'events.settings.items.price-column-header')
            | translate
            | titlecase
        "
        >({{ eventItem.NonMemberPrice | currency }})</span
      >
      <span *ngIf="eventItem.HasMemberPricing">
        (<span [title]="'events.settings.items.price-column-header' | translate | titlecase">{{ eventItem.NonMemberPrice | currency }}</span
        >/<span [title]="'events.settings.items.member-price-column-header' | translate | titlecase">{{
          eventItem.MemberPrice | currency
        }}</span
        >)
      </span>
    </div>
  </div>

  <app-back-to-top></app-back-to-top>
</div>

<p-dialog
  #eventItemEditModal
  modal="true"
  [(visible)]="showEditModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">
      {{ 'events.settings.items.title-singular' | translate | titlecase }}
      <span *ngIf="selectedEventItem.EventItemId > 0">
        {{ 'events.settings.items.title-singular-id' | translate | uppercase }} {{ selectedEventItem.EventItemId }}</span
      >
    </h4>
  </ng-template>
  <p [hidden]="!loadingEventItem"><wl-busy show="loadingEventItem"></wl-busy> {{ 'common.loading' | translate | titlecase }}...</p>
  <div class="container-fluid" [hidden]="loadingEventItem">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.descr-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input class="form-control" type="text" data-cy="inputEventSettingsItemName" [(ngModel)]="selectedEventItem.Descr" required />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.attendees-for-item-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input
            class="form-control"
            type="text"
            data-cy="inputEventSettingsItemAttendeeNumber"
            [(ngModel)]="selectedEventItem.AttendeesForItem"
          />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.revenue-item-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <wl-revenue-item-selector
            [(ngModel)]="selectedEventItem.ItemNum"
            (onRevenueItemChanged)="revenueItemChanged($event)"
            data-cy="inputEventSettingsRevenueItemNum"
          ></wl-revenue-item-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.payment-types-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <p-select
            appendTo="body"
            [(ngModel)]="selectedEventItem.PaymentTypeId"
            [style]="{ width: '100%' }"
            [options]="paymentTypeItems"
            placeholder="'common.none' | translate | titlecase"
            showClear
          ></p-select>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" [(ngModel)]="selectedEventItem.IsSponsorShip" />
            {{ 'events.settings.items.is-a-sponsorship-label' | translate | titlecase }}
          </label>
          <div>
            <label>
              <input type="checkbox" [(ngModel)]="selectedEventItem.IsPublic" />
              {{ 'events.settings.items.is-public-label' | translate | titlecase }}
              <img
                class="wc-inline-icon"
                src="/assets/img/public-registration.png"
                [title]="'events.settings.items.public-registration-available' | translate"
                [alt]="'events.settings.items.public-registration-available' | translate"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.inoive-due-date-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <wl-date-selector name="eventItemInvoicDateDue" [(ngModel)]="selectedEventItem.InvoiceDateDue"></wl-date-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.sales-dates-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <span class="wl-give-calendar-right-padding">
            <wl-date-selector name="startDate" [(ngModel)]="selectedEventItem.StartDate"></wl-date-selector>
          </span>
          {{ 'events.settings.items.to-label' | translate | titlecase }}
          <wl-date-selector name="endDate" [(ngModel)]="selectedEventItem.EndDate"></wl-date-selector>
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.max-items-avail-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input class="form-control" type="text" [(ngModel)]="selectedEventItem.MaxItemsAvail" />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.max-quantity-per-registration-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input class="form-control" type="text" [(ngModel)]="selectedEventItem.LimitPerRegistration" />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.pricing-and-restrictions-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <label
              ><input
                type="checkbox"
                [(ngModel)]="selectedEventItem.HasMemberPricing"
                (ngModelChange)="handleEventItemEditHasMemberPricingChecked()"
              />
              {{ 'events.settings.items.member-nonmember-pricing-label' | translate | titlecase }}</label
            >
          </div>
        </div>
      </div>
      <div class="form-group" [hidden]="selectedEventItem.HasMemberPricing">
        <label class="col-sm-3 control-label" *ngIf="!selectedEventItem.MembersOnly">
          {{ 'events.settings.items.unit-price-label' | translate | titlecase }}
        </label>
        <label class="col-sm-3 control-label" *ngIf="selectedEventItem.MembersOnly">
          {{ 'events.settings.items.member-price-label' | translate | titlecase }}
        </label>
        <div class="col-sm-9">
          <input
            class="form-control"
            type="text"
            data-cy="inputEventSettingsItemPrice"
            *ngIf="!selectedEventItem.MembersOnly"
            [(ngModel)]="selectedEventItem.NonMemberPrice"
          />
          <input class="form-control" type="text" *ngIf="selectedEventItem.MembersOnly" [(ngModel)]="selectedEventItem.MemberPrice" />
        </div>
      </div>
      <div class="form-group" [hidden]="!selectedEventItem.HasMemberPricing">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.nonmember-price-label' | translate | titlecase }}
        </label>
        <div class="col-sm-3">
          <input class="form-control" type="text" [(ngModel)]="selectedEventItem.NonMemberPrice" />
        </div>
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.member-price-label' | translate | titlecase }}
        </label>
        <div class="col-sm-3">
          <input class="form-control" type="text" [(ngModel)]="selectedEventItem.MemberPrice" />
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" [(ngModel)]="selectedEventItem.Taxable" />
            {{ 'events.settings.items.is-taxable-label' | translate | titlecase }}
          </label>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <div>
            <label [ngClass]="{ disabled: selectedEventItem.HasMemberPricing }">
              <input
                type="checkbox"
                [(ngModel)]="selectedEventItem.MembersOnly"
                [disabled]="selectedEventItem.HasMemberPricing"
                [hidden]="selectedEventItem.HasMemberPricing"
                (ngModelChange)="handleMembersOnlyChanged()"
              />
              <input type="checkbox" [hidden]="!selectedEventItem.HasMemberPricing" disabled />
              {{ 'events.settings.items.members-only-label' | translate | titlecase }}
            </label>
          </div>
          <div>
            <label>
              <input
                type="checkbox"
                [(ngModel)]="selectedEventItem.AllowRelateProfileMemberPrice"
                [disabled]="!selectedEventItem.MembersOnly && !selectedEventItem.HasMemberPricing"
                [hidden]="!selectedEventItem.MembersOnly && !selectedEventItem.HasMemberPricing"
              />
              <input type="checkbox" disabled [hidden]="selectedEventItem.MembersOnly || selectedEventItem.HasMemberPricing" />
              {{ 'events.settings.items.allow-related-profile-member-price-label' | translate | titlecase }}
            </label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" [(ngModel)]="selectedEventItem.RestrictForAffiliations" />
            {{ 'events.settings.items.restrict-for-affiliations-label' | translate | titlecase }}
          </label>
        </div>
      </div>
      <div class="form-group" [hidden]="!selectedEventItem.RestrictForAffiliations">
        <div class="col-sm-offset-3 col-sm-9">
          <wl-affcode-selector #affCodeSelectorComponent [(ngModel)]="selectedEventItem.AffCodes"></wl-affcode-selector>
        </div>
      </div>
      <div [hidden]="!selectedEventItem.MembersOnly && !selectedEventItem.RestrictForAffiliations">
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.settings.items.teaser-message-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [(ngModel)]="selectedEventItem.TeaserMessage" />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'events.settings.items.restricted-message-label' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" type="text" [(ngModel)]="selectedEventItem.RestrictedMessage" />
          </div>
        </div>
      </div>
      <div class="form-group" [hidden]="!selectedEventItem.MembersOnly && !selectedEventItem.RestrictForAffiliations">
        <div class="col-sm-offset-3 col-sm-9">
          <label>
            <input type="checkbox" [(ngModel)]="selectedEventItem.ShowForEligibleUsersOnly" />
            {{ 'events.settings.items.show-for-eligible-users-only-label' | translate | titlecase }}
          </label>
          <img
            src="/assets/img/help.png"
            title="{{ 'events.settings.items.show-for-eligible-users-only-tooltip-label' | translate }}"
            class="wc-help-icon"
          />
        </div>
      </div>
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ 'events.settings.items.ceus-label' | translate }}
        </label>
        <div class="col-sm-9">
          <div class="form-control-static">
            <wl-event-item-credit-type-list [eventItemCreditTypes]="selectedEventItem.CreditTypes"></wl-event-item-credit-type-list>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div [hidden]="loadingEventItem">
      <div class="alert alert-danger text-left" [hidden]="!editError">
        {{ editError }}
      </div>

      <div class="alert alert-danger" *ngIf="!loadingEventItem && !saving && showEventItemPriceChangeWarning">
        {{ 'events.settings.items.price-change-warning' | translate }}
      </div>

      <wl-busy [show]="saving"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-primary"
        data-cy="btnEventSettingsSaveEventItem"
        (click)="saveEventItem()"
        [disabled]="saving"
        icon="pi pi-save"
      >
        <span [hidden]="saving">{{ 'common.save' | translate | titlecase }}</span>
        <span [hidden]="!saving">{{ 'common.saving' | translate | titlecase }}</span>
      </button>

      <button pButton type="button" class="btn btn-secondary" (click)="this.showEditModal = false" [disabled]="saving" icon="pi pi-ban">
        {{ 'common.cancel' | translate | titlecase }}
      </button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #eventItemDeleteConfirmationModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <p [hidden]="checkingDelete.busy || !checkingDelete.success || eventItemHasRegistrations">
    {{ 'events.settings.items.delete-prompt' | translate }}
  </p>
  <p [hidden]="!eventItemHasRegistrations">{{ 'events.settings.items.delete-event-item-has-registrations-message' | translate }}</p>

  <wl-busy [show]="checkingDelete.busy"></wl-busy>

  <div class="alert alert-danger text-left" [hidden]="checkingDelete.success || !checkingDelete.message">
    {{ checkingDelete.message }}
  </div>

  <ng-template pTemplate="footer">
    <div [hidden]="checkingDelete.busy">
      <div class="alert alert-danger text-left" [hidden]="!deleteError">
        {{ deleteError }}
      </div>
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-danger"
        (click)="deleteEventItemConfirmed()"
        [disabled]="deleting || eventItemHasRegistrations || !checkingDelete.success"
        icon="pi pi-trash"
      >
        <span [hidden]="!deleting">
          {{ 'common.deleting' | translate | titlecase }}
        </span>
        <span [hidden]="deleting">
          {{ 'common.delete' | translate | titlecase }}
        </span>
      </button>

      <button pButton type="button" class="btn btn-secondary" (click)="this.showDeleteModal = false" [disabled]="deleting" icon="pi pi-ban">
        {{ 'common.cancel' | translate | titlecase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
